import { AppShell, Burger, Flex, Image, Button } from '@mantine/core';
import { NavbarButton } from '@shared/ui';
import { useFeatureFlag } from '@packages/feature-flags/react';
import {
  IconListDetails,
  IconClipboardList,
  IconBuildingSkyscraper,
  IconUsers,
  IconSettings2,
  IconDoorExit,
  IconMessage2,
} from '@tabler/icons-react';
import { useSignOut } from '@entities/auth/api/hooks/mutations';
import { Link } from 'react-router';

import classes from './navbar.module.scss';

type NavbarProps = {
  opened: boolean;
  toggle: () => void;
};

export const Navbar = ({ opened, toggle }: NavbarProps) => {
  const { mutate: signOut, isPending } = useSignOut();
  const ratingsAndReviewsEnabled = useFeatureFlag('ratingsAndReviews');

  const handleSignOut = () => {
    signOut();
  };

  return (
    <AppShell.Navbar>
      <Flex gap={48} direction='column' h='100%'>
        <Flex justify='space-between' align='center' w='100%'>
          <Link to='/' onClick={toggle}>
            <Image
              src='/headerLogo.svg'
              w={207}
              h={46}
              alt='logo'
              className={classes.logo}
            />
          </Link>

          <Burger opened={opened} onClick={toggle} hiddenFrom='sm' size='sm' />
        </Flex>

        <Flex direction='column' gap={48}>
          <Flex direction='column' gap={4}>
            <NavbarButton
              to='/'
              icon={<IconListDetails />}
              isMainPage
              activeStartWith='/user-list'
              onNavClick={toggle}
            >
              Пользователи
            </NavbarButton>

            <NavbarButton
              to='/company-list'
              icon={<IconBuildingSkyscraper />}
              onNavClick={toggle}
            >
              Компании
            </NavbarButton>

            <NavbarButton
              to='/vacancy-list'
              icon={<IconClipboardList />}
              onNavClick={toggle}
            >
              Вакансии
            </NavbarButton>

            <NavbarButton
              to='/candidate-list'
              icon={<IconUsers />}
              onNavClick={toggle}
            >
              Кандидаты
            </NavbarButton>

            {ratingsAndReviewsEnabled && (
              <NavbarButton
                to='/reviews'
                icon={<IconMessage2 />}
                onNavClick={toggle}
              >
                Отзывы
              </NavbarButton>
            )}

            <NavbarButton
              to='/settings'
              icon={<IconSettings2 />}
              menuItems={[
                {
                  to: '/settings/ai-constants-list',
                  label: 'Константы ИИ',
                },
                {
                  to: '/vacancies-templates-list',
                  label: 'Шаблоны вакансий',
                },
              ]}
              onNavClick={toggle}
            >
              Настройки
            </NavbarButton>
          </Flex>
        </Flex>

        <Button
          variant='unstyled'
          onClick={handleSignOut}
          loading={isPending}
          className={classes.buttonNavbar}
        >
          <Flex gap={12} align='center'>
            <IconDoorExit />
            Выйти
          </Flex>
        </Button>
      </Flex>
    </AppShell.Navbar>
  );
};
